/*
 * UI-only feature toggles (backend routes remain available).
 */

export const UI_FEATURE_FLAGS = {
  showBadges: false,
};
